import { Component,OnInit } from '@angular/core';


@Component({
  selector: 'upsc-business-services',
  templateUrl: './business-services.component.html',
  styleUrls: ['./business-services.component.scss']
})
export class BusinessServicesComponent implements OnInit {

  ngOnInit(): void {
  }
}
